import { useContext, useEffect, useMemo } from 'react';
import {BrowserRouter,Route, Routes } from 'react-router-dom';
import { Context } from './index';
import { ToastContainer, Bounce } from 'react-toastify';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import './App.css';
import './content/css/Toastify.css';
import './content/css/Tooltip.css';
import './content/css/tippy.css';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import MainPage from './components/Pages/Main/Main';
import WipeBlock from './components/Pages/WipeBlock/WipeBlock';
import Rules from './components/Pages/Rules/Rules';
import Servers from './components/Pages/Servers/Servers';
import Kits from './components/Pages/Kits/Kits';
import Profile from './components/Pages/Profile/Profile';
import ToS from './components/Pages/ToS/ToS';
import DonateModal from './components/Modal/DonateModal';

export default function App() {
  const { i18n } = useTranslation(),
  languages = i18n.languages
  if (languages.includes('en')) {
    moment.locale('en')
  } else if (languages.includes('ru')) moment.locale('ru')

  const {store} = useContext(Context)
  useEffect(()=> {
    store.checkAuth()
    store.autoRefreshUser()
  }, [])
  useMemo(() => {
    store.getDepositBonuses()
    store.getKits()
}, [])
  
  return(
    <>
      <DonateModal />
      <BrowserRouter>
          <Header />
          <Routes>
              <Route path="*" element={<MainPage />} />
              <Route path="/profile/*" element={<Profile />} />
              <Route path="/servers" element={<Servers />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/kits" element={<Kits />} />
              <Route path="/wipeblock" element={<WipeBlock />} />
              <Route path="/tos" element={<ToS />} />
          </Routes>
          <Footer />
      </BrowserRouter>
      {createPortal(
        <ToastContainer position= "top-right"
        autoClose= {5000}
        hideProgressBar= {false}
        closeOnClick= {true}
        closeButton= {false}
        pauseOnHover= {false}
        pauseOnFocusLoss={false}
        draggable= {true}
        theme= "dark"
        transition= {Bounce} />,
        document.getElementById('notify')!
      )}
    </>
  )
}
